const { Fragment, Component } = wp.element
const { Dropdown, ColorPicker, Tooltip, ColorPalette, Dashicon, TextControl, TabPanel, RangeControl, Popover } = wp.components
import './components.scss'
import { __ } from '@wordpress/i18n';
// import "./editor.scss"
import Nexter_Icons from './icons'
// import Nexter_Help from './help'
import { nexterfieldChange } from '../components/helper-function'
const { GradientPicker } = wp.components
const { MediaUpload } = wp.blockEditor;

import FontFamilyControl from "../components/font-typography"
import TypographyStyles from "../components/inline-styles"

function nexter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; }  return obj; }

class Nexter_Device extends Component {
    constructor(props) {
        super(props)
        this.state = { current: typeof props.device !== 'undefined' && props.device !== '' ? props.device : 'md' }
        this.setDeviceType = this.setDeviceType.bind( this );
    }
    componentDidMount() {
        if (typeof this.props.device !== 'undefined' && this.props.device !== '') {
            window.nexterDevice = this.props.device
        }
    }
    setDeviceType( deviceType ) {
        this.props.setDeviceType( deviceType );
    }
    setSettings(value) {
        window.nexterDevice = value
        this.setDeviceType( value );
        this.setState({ current: value })
        this.props.onChange(value)
    }

    render() {
        const { current } = this.state
        const { device, className, commonResponsiveDevice, align } = this.props

        return (
            <div className={'nexter-device '+(className ? className : '') +(align=='bottom' ? ' device-bottom' : '') + ' ' + ((commonResponsiveDevice && device != '' || !commonResponsiveDevice && current != '') ? 'active-'+current : '')}>
                <button onClick={() => this.setSettings('md')} title={__('Desktop', 'nexter-extension')} className={"nexter-device-desktop" + ((commonResponsiveDevice && device == 'md' || !commonResponsiveDevice && current == 'md') ? ' active' : '')} ><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M1.5 1.36364C1.20991 1.36364 0.974747 1.5988 0.974747 1.88889V6.33333C0.974747 6.62342 1.20991 6.85859 1.5 6.85859H5.03986C5.04518 6.85836 5.05053 6.85824 5.0559 6.85824C5.06128 6.85824 5.06663 6.85836 5.07195 6.85859H8.61111C8.9012 6.85859 9.13636 6.62342 9.13636 6.33333V1.88889C9.13636 1.5988 8.9012 1.36364 8.61111 1.36364H1.5ZM5.41954 7.58586H8.61111C9.30286 7.58586 9.86364 7.02508 9.86364 6.33333V1.88889C9.86364 1.19714 9.30286 0.636364 8.61111 0.636364H1.5C0.808249 0.636364 0.247475 1.19714 0.247475 1.88889V6.33333C0.247475 7.02508 0.808249 7.58586 1.5 7.58586H4.69227V8.63636H3.27778C3.07695 8.63636 2.91414 8.79917 2.91414 9C2.91414 9.20083 3.07695 9.36364 3.27778 9.36364H6.83333C7.03416 9.36364 7.19697 9.20083 7.19697 9C7.19697 8.79917 7.03416 8.63636 6.83333 8.63636H5.41954V7.58586Z" fill="#010101"/></svg></button>
				<button onClick={() => this.setSettings('sm')} title={__('Tablet', 'nexter-extension')} className={"nexter-device-tablet" + ((commonResponsiveDevice && device == 'sm' || !commonResponsiveDevice && current == 'sm') ? ' active' : '')} ><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M0.98616 1.32927C0.963662 1.37565 0.93913 1.4661 0.93913 1.63707V5.78333H9.05556V1.63707C9.05556 1.4661 9.03102 1.37565 9.00853 1.32927C8.99137 1.29389 8.97149 1.27427 8.93206 1.25587C8.88114 1.2321 8.79755 1.21162 8.65647 1.20044C8.51662 1.18935 8.35073 1.18913 8.14218 1.18913H1.8525C1.64396 1.18913 1.47806 1.18935 1.33822 1.20044C1.19713 1.21162 1.11354 1.2321 1.06262 1.25587C1.02319 1.27427 1.00332 1.29389 0.98616 1.32927ZM9.05556 6.47246H0.93913V7.97707C0.93913 8.10702 0.973503 8.17763 1.00794 8.22103C1.046 8.26898 1.10754 8.3125 1.20175 8.34741C1.40208 8.42165 1.6547 8.425 1.8525 8.425H8.14218C8.33999 8.425 8.59261 8.42165 8.79294 8.34741C8.88714 8.3125 8.94869 8.26898 8.98674 8.22103C9.02118 8.17763 9.05556 8.10702 9.05556 7.97707V6.47246ZM1.84298 0.5H8.15171C8.34867 0.499997 8.54097 0.499993 8.71091 0.51346C8.88234 0.527045 9.06213 0.556089 9.22349 0.631389C9.39633 0.712051 9.53763 0.841018 9.62858 1.02854C9.71418 1.20504 9.74469 1.41178 9.74469 1.63707V7.97707C9.74469 8.24336 9.66899 8.46993 9.52653 8.64943C9.38769 8.82437 9.20551 8.92945 9.0324 8.9936C8.70646 9.11439 8.34055 9.11422 8.15602 9.11413C8.15129 9.11413 8.14667 9.11413 8.14218 9.11413H1.8525C1.84801 9.11413 1.8434 9.11413 1.83867 9.11413C1.65413 9.11422 1.28822 9.11439 0.962281 8.9936C0.789176 8.92945 0.606994 8.82437 0.468154 8.64943C0.325697 8.46993 0.25 8.24336 0.25 7.97707V1.63707C0.25 1.41178 0.280503 1.20504 0.366109 1.02854C0.457057 0.841018 0.598352 0.712051 0.7712 0.631389C0.932557 0.556089 1.11235 0.527045 1.28378 0.51346C1.45372 0.499993 1.64601 0.499997 1.84298 0.5ZM4.65278 7.44873C4.65278 7.25843 4.80704 7.10417 4.99734 7.10417H5.00175C5.19204 7.10417 5.34631 7.25843 5.34631 7.44873C5.34631 7.63903 5.19204 7.7933 5.00175 7.7933H4.99734C4.80704 7.7933 4.65278 7.63903 4.65278 7.44873Z" fill="black"/></svg></button>
                <button onClick={() => this.setSettings('xs')} title={__('Phone', 'nexter-extension')} className={"nexter-device-mobile" + ((commonResponsiveDevice && device == 'xs' || !commonResponsiveDevice && current == 'xs') ? ' active' : '')} ><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M2.7 0.800001C2.36863 0.800001 2.1 1.06863 2.1 1.4V6.5H7.8V1.4C7.8 1.06863 7.53137 0.800001 7.2 0.800001H2.7ZM7.8 7.1H2.1V8.6C2.1 8.93137 2.36863 9.2 2.7 9.2H7.2C7.53137 9.2 7.8 8.93137 7.8 8.6V7.1ZM1.5 1.4C1.5 0.737259 2.03726 0.200001 2.7 0.200001H7.2C7.86274 0.200001 8.4 0.737259 8.4 1.4V8.6C8.4 9.26274 7.86274 9.8 7.2 9.8H2.7C2.03726 9.8 1.5 9.26274 1.5 8.6V1.4ZM4.65 8.15C4.65 7.98432 4.78431 7.85 4.95 7.85H4.9545C5.12019 7.85 5.2545 7.98432 5.2545 8.15C5.2545 8.31569 5.12019 8.45 4.9545 8.45H4.95C4.78431 8.45 4.65 8.31569 4.65 8.15Z" fill="black"/></svg></button>
            </div>
        )
    }
}

class Nexter_Note extends Component {
    constructor(props) {
        super(props)
    }
	
    render() {
        const { label, separator, color, description } = this.props
		const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';
		const styleColor = (color!='') ? { color: color } : '';
        return (
			<div className={'nexter-field nexter-field-note ' + (sep ? sep : '')} >
				<span style={styleColor}>{ label ? label : __('Note : ', 'nexter-extension') }</span>
				{ description!='' ? <span dangerouslySetInnerHTML={{ __html: description }}></span> : '' }
			</div>
        )
    }
}

class Nexter_Text extends Component {
    constructor(props) {
        super(props)
        this.state = { current: '' }
    }
    
	setSettings(val) {
        const { value, onChange } = this.props
		let final = val;
        onChange(final)
        this.setState({ current: final })
    }
	
    render() {
        const { label, value, type, min, max, step, help, className, inlineblock, separator, placeholder  , diff  } = this.props
        
		const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';
		
		const typeval = (type!='' && type!=undefined) ? type : 'text';
		
		const inline_content = inlineblock==false ? '' : 'nexter-inline-block nexter-d-flex';
		const inline_content_text = inlineblock==false ? 'nexter-mt-5' : '';
		const placeholder_text = (placeholder) ? placeholder : '';
		
        return (
			<div className={"nexter-field-text nexter-field " + inline_content + ' '+ (sep ? sep : '') }>
               
			   	{label && <label  className={ nexterfieldChange( diff , value ) } >{label}
					{/* <Nexter_Help>{help}</Nexter_Help> */}
					</label>}
				
				<div className={"nexter-field-child "+ inline_content_text }>
						<TextControl
							label={""}
							type={typeval}
							min={min || 0}
							step={step || 1}
							max={max || 10000}
							value={ value }
							className={className}
							placeholder={placeholder_text}
							onChange={ ( val ) => this.setSettings( val ) }
						/>
                </div>
            </div>
        )
    }
}

class Nexter_RadioAdvanced extends Component {

    constructor(props) {
        super(props)
        this.state = { current: this._filterValue() }
    }

    _filterValue() {
        const { value,responsive, device } = this.props
        return value ? (responsive ? (value[device] || '') : value) : '';
    }

    setSettings(val){

        const { value,responsive,responsiveGroup,onChange, name, device } = this.props
        var final = responsive || responsiveGroup ? Object.assign({}, value, nexter_defineProperty({}, device, val)) : val;

        onChange( final )
        this.setState({ current: final })
    }

    render() {
        const { value, responsive,device,onDeviceChange ,label, options, separator , inlineblock , diff } = this.props;
		const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';
        const inlinecontent = inlineblock==true ? ' nexter-block-inline' : '';
        return (
            <div className={"nexter-field nexter-field-radio-advanced nexter-d-flex nexter-align-center " + (sep ? sep : '') + inlinecontent }>
                { label &&
                    <span>{label}</span>
                }
                <div className={`nexter-field-button-list${ inlineblock==true ? '' : ' nexter-ml-auto' }`}>
                    {
                        options.map((data, index) => {
                            return (
                                <Tooltip text={ data.title || data.value } key={index.toString()}>
                                    <button className={(this._filterValue() == data.value ? 'active' : '') + ' nexter-button'} key={index} onClick={ () => this.setSettings( this._filterValue() == data.value ? '' : data.value )} >
                                        {data.icon ? (<i className={ data.icon } />)
                                        : data.svg ? (<span className='nexter-option-svg'>{data.svg}</span>)
                                        : data.label}
                                    </button>
                                </Tooltip>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}

class Nexter_Color extends Component {
    constructor(props) {
        super(props)
		this.state = { Status : false }
	}
	
    render() {
        const { label, className, value, disablePalette, disableAlpha, disableClear, disableGlobal, onChange, separator, help , diff } = this.props
		const { Status } =this.state

		let colorSelected = (value && value != '') ? 'nxt-remove-bg-img' : '';
		
		const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';
		
        return (
            <div className={`nexter-field nexter-field-color nexter-d-flex nexter-inline-block ${className ? className : ''} ${sep} ${ !disableGlobal ? 'nexter-colglo' : '' }`}>
                {label && <label className={"nexter-mb-0" + nexterfieldChange( diff , value )}>{label}{/* <Nexter_Help>{help}</Nexter_Help> */}</label>}
                <div className={"nexter-flex"}>
				{(value != '' && !disableClear) &&
                    <div className="nexter-reset-color">
						<Tooltip text={__('Clear', 'nexter-extension')}>
                            <span className="nexter-border-clear nexter-flex" onClick={() => {onChange(''); this.setState({Status: false }); } } role="button">
								{Nexter_Icons.ClearIcon}
							</span>
						</Tooltip>
                    </div>
                }
				<Dropdown
                    popoverProps={ { placement: 'top-start' } }
                    className={"nexter-ml-auto"}
					contentClassName="nexter-popover-style"
                    renderToggle={({ isOpen, onToggle }) => (
                        <Fragment>
                            <span className="nexter-color-picker-container">
                                <button className={"nexter-color-picker "+colorSelected} style={{backgroundColor: value || '',borderColor: value || ''}} isPrimary onClick={onToggle} aria-expanded={isOpen} />
                            </span>
                        </Fragment>
                    )}
                    renderContent={() => (
                        <span>
                            <ColorPicker color={value || ''}
                                onChangeComplete={val => {
                                    if (val.rgb) { onChange(val.rgb.a != 1 ? 'rgba(' + val.rgb.r + ',' + val.rgb.g + ',' + val.rgb.b + ',' + val.rgb.a + ')' : val.hex) }
									this.setState({Status: false });
                                }}
                                disableAlpha={disableAlpha ? disableAlpha : false} />
                        </span>
                    )}
                />
                </div>
            </div>
        )
    }
}

class Nexter_Media extends Component {

	setSettings( media ) {
		const { multiple, onChange,value} = this.props
		if( multiple ){
			let media_list = [];
			media.forEach( single => {
				if ( single && single.url ){
					media_list.push( {url: single.url, id: single.id, title: media.title , alt: media.alt} );
				}
			});
			onChange( value ? value.concat(media_list) : media_list );
		}else{
			if ( media && media.url ) {
				onChange({url: media.url, id: media.id, title: media.title, alt: media.alt , sizes : media.sizes , caption : media.caption});
			}
		}
	}

	removeImage( id ){
		const { multiple, onChange } = this.props
		if( multiple ){
			let value = (this.props.value).slice()
			value.splice(id, 1)
			onChange( value )
		}else{
			onChange({})
		}
	}

	isUrl(url){
		if( ['wbm','jpg','jpeg','gif','png', 'svg','webp'].indexOf( url.split('.').pop().toLowerCase() ) != -1 ){
			return url;
		}else if(['mp4','m4v','mov','wmv','avi', 'mpg', 'ogv', '3gp'].indexOf( url.split('.').pop().toLowerCase() ) != -1){
			return nxtext_ajax_object.dashData.pluginpath + 'assets/images/nexter-ext-video-placeholder.jpg';
		}else{
			return nxtext_ajax_object.dashData.pluginpath + 'assets/images/nexter-ext-placeholder.jpg';
		}
	}
	
	isVideoUrl(url){
		if( ['mp4','m4v','mov','wmv','avi', 'mpg', 'ogv', '3gp'].indexOf( url.split('.').pop().toLowerCase() ) != -1 ){
			return true;
		}else{
			return false;
		}
	}
	

	render() {
		const { type,multiple,value,panel,separator, help , diff } = this.props;
		const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';
		return (
			<div className={'nexter-media ' + (sep ? sep : '')}>
				{ this.props.label &&
					<label className={ nexterfieldChange( diff , value , '' , '' , '' , '' , true ) } >{this.props.label}{/* <Nexter_Help>{help}</Nexter_Help> */}</label>
				}
				<MediaUpload
					onSelect={ val => this.setSettings(val) }
					allowedTypes={ type || ['image'] }
					multiple={ multiple || false }
					value={ value }
					render={({ open }) => (
						<div className={"nexter-single-img "+(multiple ? 'nexter-multi-img' : '')}>
							<div>
								{ multiple ?
									<div>
										{ ( value.length > 0 ) &&
											value.map( (v,index) => {
												return(
													<span className="nexter-media-image-parent" key={index.toString()} >
														<img src={this.isUrl(v.url)} alt={__('image', 'nexter-extension')}/>
														{ (this.isVideoUrl(v.url) && type.includes("video") && v.title) &&
															<span className={'nexter-media-video-title'}>{v.title || ''}</span>
														}
														{ panel &&
															<div className="nexter-media-actions nexter-field-button-list">
																<Tooltip text={__('Delete', 'nexter-extension')} delay={0} placement={'top'}>
																	<button className="nexter-button nexter-media-remove" aria-label={__('Remove', 'nexter-extension')} onClick={ () => this.removeImage(value.id) } role="button">
																		{ Nexter_Icons.mediaDelete }
																	</button>
																</Tooltip>
															</div>
														}
													</span>
												)
											} )
										}
										<div onClick={open} className={"nexter-placeholder-image"}>
											<Tooltip text={__( 'Insert', 'nexter-extension' )} delay={0} >
												<span className={`nexter-field-border-type nexter-d-flex nexter-align-center`} >
													<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_523_6822)"><path d="M7.99979 5.33341V10.6667M5.33403 7.99994H10.6674M14.957 7.99998C14.957 11.842 11.8424 14.9565 8.00047 14.9565C4.15849 14.9565 1.04395 11.842 1.04395 7.99998C1.04395 4.158 4.15849 1.04346 8.00047 1.04346C11.8424 1.04346 14.957 4.158 14.957 7.99998Z" stroke="black" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"/></g><defs><clipPath id="clip0_523_6822"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>
												</span>
											</Tooltip>
										</div>
									</div>
									:
									( ( value && value.url ) ? 
										<span className="nexter-media-image-parent"> 
											<img src={this.isUrl(value.url)} alt={__('image', 'nexter-extension')}/>
											{(this.isVideoUrl(value.url) && type.includes("video") && value.title) &&
												<span className={'nexter-media-video-title'}>{value.title || ''}</span>
											}
											{ panel &&
												<div className="nexter-media-actions nexter-field-button-list">
													<Tooltip text={__('Delete', 'nexter-extension')} delay={0} placement={'top'}>
														<button className="nexter-button nexter-media-remove" aria-label={__('Remove', 'nexter-extension')} onClick={ () => this.removeImage(value.id) } role="button">
															{ Nexter_Icons.mediaDelete }
														</button>
													</Tooltip>
												</div>
											}
										</span>
										:
										<div onClick={open} className={"nexter-placeholder-image"}>
											<Tooltip text={__( 'Insert', 'nexter-extension' )} delay={0} >
												<span className={`nexter-field-border-type nexter-d-flex nexter-align-center`} >
													<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_523_6822)"><path d="M7.99979 5.33341V10.6667M5.33403 7.99994H10.6674M14.957 7.99998C14.957 11.842 11.8424 14.9565 8.00047 14.9565C4.15849 14.9565 1.04395 11.842 1.04395 7.99998C1.04395 4.158 4.15849 1.04346 8.00047 1.04346C11.8424 1.04346 14.957 4.158 14.957 7.99998Z" stroke="black" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"/></g><defs><clipPath id="clip0_523_6822"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>
												</span>
											</Tooltip>
										</div>
									)
								}
							</div>
							<div className="nexter-img-bottom" onClick={open} > { 
								(value && value.url) ? 
									(type.includes("video") ? __( 'Replace Video', 'nexter-extension' ) :
									type.includes("image/svg+xml") ? __( 'Replace SVG', 'nexter-extension' ) :
									__( 'Replace Image', 'nexter-extension' )) : 
								(type.includes("video") ? __( 'Upload Video', 'nexter-extension' ) :
								type.includes("image/svg+xml") ? __( 'Upload SVG', 'nexter-extension' ) :
								__( 'Upload Image', 'nexter-extension' ))
								} </div>
						</div>
					)}
				/>
			</div>
		);
	}
}

class Nexter_Select extends Component {
    constructor(props) {
        super(props)
        this.state = { current: '', device: 'md' }
    }
    _filterValue() {
        const { value, responsive, device } = this.props
		return value ? (responsive ? (value[device] || '') : value) : '';
    }
    setSettings(val) {
        const { value, onChange, responsive, device } = this.props
		let final = responsive ? Object.assign({}, value, nexter_defineProperty({}, device, val)) : val;
        onChange(final)
        this.setState({ current: final })
    }
	
    render() {
        const { label, responsive, device, onDeviceChange, separator, inlineblock, help , diff } = this.props
        const direction = this.props.direction == 'left' ? '  direction-left' : this.props.direction == 'right' ? '  direction-right' : '';
		let responsiveDevice = responsive ? device ? device : this.state.device : window.nexterDevice
		const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';
		const inlinecontent = inlineblock==false ? '' : 'nexter-inline-block';
        return (
		<div className={"nexter-field-select nexter-field nexter-d-flex " + (this.props.responsive ? 'nexter-responsive' : '') +' '+ (sep ? sep : '') +' '+ inlinecontent}>
               
                {label && <label className={ "nexter-sele-lbl " +(inlineblock==false ? "nexter-mb-5" : '') + nexterfieldChange( diff ,  this.props.value , responsive , device , '', '', '', true) }>{label}{/* <Nexter_Help>{help}</Nexter_Help> */}</label>}
                {responsive && 
					<div className={'flex-device-wrap' + (inlineblock==false ? " nexter-mb-5" : '')}>
						{ (device) &&
							<Nexter_Device device={responsiveDevice} commonResponsiveDevice={device} className="nexter-ml-10" onChange={(val) => { onDeviceChange(val) }} />
						}{ (device =='') &&
							<Nexter_Device className="nexter-ml-10" onChange={(val) => { this.setState({ current: val }) }} />
						}
					</div>
				}
                <div className="nexter-field-child">
                    <div className={"nexter-popup-select " + direction} ref={node => this.node = node}>
                        {(this.props.clear && this._filterValue() != '') &&
                            <span className={'nexter-clear'} onClick={() => this.setSettings("")}><i className="fas fa-times" /></span>
                        }
                        <select value={this._filterValue()} onChange={(e) => this.setSettings(e.target.value)}>
                            {(this.props.noValue || this.props.clear) &&
                                <option value="">{this.props.noValue || this.props.initial ? this.props.initial : __('Select', 'nexter-extension')}</option>
                            }
							{ this.props.options.map((item, index) => {
								if(typeof item[0] === 'object' && item[0].label && item[0].options){
									return (<optgroup key={index.toString()} label={(item[0].label) ? item[0].label : ''}>
										{ item[0].options.map((subitem,subindex) => 
											<option value={Array.isArray(subitem) ? subitem[0] : subitem}  key={subindex.toString()} onClick={() => this.setSettings(Array.isArray(subitem) ? subitem[0] : subitem)}>{Array.isArray(subitem) ? subitem[1] : subitem}</option>
										)}
									</optgroup>)
								}else{
									return <option value={Array.isArray(item) ? item[0] : item}  key={index.toString()} onClick={() => this.setSettings(Array.isArray(item) ? item[0] : item)}>{Array.isArray(item) ? item[1] : item}</option>
								}
							}) 
							}
                        </select>
                    </div>
                </div>
            </div>
        )
    }
}

class Nexter_Gradient extends Component {

    constructor(props) {
        super(props)
        this.state = {Status : false }
    }
	
	componentWillMount(){
        const { value } = this.props
		this.props.onChange(value);
    }

    render() {
        const { value, separator } = this.props
		const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';

        const {Status} = this.state
		
        return (
            <div className={"nexter-gradient nexter-field inline " + (sep ? sep : '')}>
                { !Status &&
                    <GradientPicker 
                        gradients={
                            this.props.gradients !== undefined ? this.props.gradient : []
                        }
                        value={value === '' ? null : value || null}
                        clearable={false}
                        disableCustomGradients={false}
                        onChange={val => this.props.onChange(val)}
                    />
                }
            </div>
        )
    }
}

const control = {
    position: [ ['default', __('Default', 'nexter-extension')],
				['left top', __('Left Top', 'nexter-extension')],
				['left center', __('Left Center', 'nexter-extension')],
				['left bottom', __('Left Bottom', 'nexter-extension')],
				['center top', __('Center Top', 'nexter-extension')],
				['center center', __('Center Center', 'nexter-extension')],
				['center bottom', __('Center Bottom', 'nexter-extension')],
				['right top', __('Right Top', 'nexter-extension')],
				['right center', __('Right Center', 'nexter-extension')],
				['right bottom', __('Right Bottom', 'nexter-extension')]
		],
    attachment: [ ['default', __('Default', 'nexter-extension')],
				['scroll', __('Scroll', 'nexter-extension')],
				['fixed', __('Fixed', 'nexter-extension')]
		],
    repeat:[ ['default', __('Default', 'nexter-extension')],
			['no-repeat', __('No Repeat', 'nexter-extension')],
			['repeat', __('Repeat', 'nexter-extension')],
			['repeat-x', __('Repeat X', 'nexter-extension')],
			['repeat-y', __('Repeat Y', 'nexter-extension')]
		],
    size: [ ['default', __('Default', 'nexter-extension')],
			['auto', __('Auto', 'nexter-extension')],
			['cover', __('Cover', 'nexter-extension')],
			['contain', __('Contain', 'nexter-extension')]
		],
    parallax: [ ['none', __('None', 'nexter-extension')],
			['fixed', __('Fixed', 'nexter-extension')]
		],
	devices : [ {
		name: 'desk',
		title: <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M1.5 1.36364C1.20991 1.36364 0.974747 1.5988 0.974747 1.88889V6.33333C0.974747 6.62342 1.20991 6.85859 1.5 6.85859H5.03986C5.04518 6.85836 5.05053 6.85824 5.0559 6.85824C5.06128 6.85824 5.06663 6.85836 5.07195 6.85859H8.61111C8.9012 6.85859 9.13636 6.62342 9.13636 6.33333V1.88889C9.13636 1.5988 8.9012 1.36364 8.61111 1.36364H1.5ZM5.41954 7.58586H8.61111C9.30286 7.58586 9.86364 7.02508 9.86364 6.33333V1.88889C9.86364 1.19714 9.30286 0.636364 8.61111 0.636364H1.5C0.808249 0.636364 0.247475 1.19714 0.247475 1.88889V6.33333C0.247475 7.02508 0.808249 7.58586 1.5 7.58586H4.69227V8.63636H3.27778C3.07695 8.63636 2.91414 8.79917 2.91414 9C2.91414 9.20083 3.07695 9.36364 3.27778 9.36364H6.83333C7.03416 9.36364 7.19697 9.20083 7.19697 9C7.19697 8.79917 7.03416 8.63636 6.83333 8.63636H5.41954V7.58586Z" fill="#010101"/></svg>,
		className: 'nexter-responsive-tabs',
	},
	{
		name: 'tablet',
		title: <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M0.98616 1.32927C0.963662 1.37565 0.93913 1.4661 0.93913 1.63707V5.78333H9.05556V1.63707C9.05556 1.4661 9.03102 1.37565 9.00853 1.32927C8.99137 1.29389 8.97149 1.27427 8.93206 1.25587C8.88114 1.2321 8.79755 1.21162 8.65647 1.20044C8.51662 1.18935 8.35073 1.18913 8.14218 1.18913H1.8525C1.64396 1.18913 1.47806 1.18935 1.33822 1.20044C1.19713 1.21162 1.11354 1.2321 1.06262 1.25587C1.02319 1.27427 1.00332 1.29389 0.98616 1.32927ZM9.05556 6.47246H0.93913V7.97707C0.93913 8.10702 0.973503 8.17763 1.00794 8.22103C1.046 8.26898 1.10754 8.3125 1.20175 8.34741C1.40208 8.42165 1.6547 8.425 1.8525 8.425H8.14218C8.33999 8.425 8.59261 8.42165 8.79294 8.34741C8.88714 8.3125 8.94869 8.26898 8.98674 8.22103C9.02118 8.17763 9.05556 8.10702 9.05556 7.97707V6.47246ZM1.84298 0.5H8.15171C8.34867 0.499997 8.54097 0.499993 8.71091 0.51346C8.88234 0.527045 9.06213 0.556089 9.22349 0.631389C9.39633 0.712051 9.53763 0.841018 9.62858 1.02854C9.71418 1.20504 9.74469 1.41178 9.74469 1.63707V7.97707C9.74469 8.24336 9.66899 8.46993 9.52653 8.64943C9.38769 8.82437 9.20551 8.92945 9.0324 8.9936C8.70646 9.11439 8.34055 9.11422 8.15602 9.11413C8.15129 9.11413 8.14667 9.11413 8.14218 9.11413H1.8525C1.84801 9.11413 1.8434 9.11413 1.83867 9.11413C1.65413 9.11422 1.28822 9.11439 0.962281 8.9936C0.789176 8.92945 0.606994 8.82437 0.468154 8.64943C0.325697 8.46993 0.25 8.24336 0.25 7.97707V1.63707C0.25 1.41178 0.280503 1.20504 0.366109 1.02854C0.457057 0.841018 0.598352 0.712051 0.7712 0.631389C0.932557 0.556089 1.11235 0.527045 1.28378 0.51346C1.45372 0.499993 1.64601 0.499997 1.84298 0.5ZM4.65278 7.44873C4.65278 7.25843 4.80704 7.10417 4.99734 7.10417H5.00175C5.19204 7.10417 5.34631 7.25843 5.34631 7.44873C5.34631 7.63903 5.19204 7.7933 5.00175 7.7933H4.99734C4.80704 7.7933 4.65278 7.63903 4.65278 7.44873Z" fill="black"/></svg>,
		className: 'nexter-responsive-tabs',
	},
	{
		name: 'mobile',
		title: <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M2.7 0.800001C2.36863 0.800001 2.1 1.06863 2.1 1.4V6.5H7.8V1.4C7.8 1.06863 7.53137 0.800001 7.2 0.800001H2.7ZM7.8 7.1H2.1V8.6C2.1 8.93137 2.36863 9.2 2.7 9.2H7.2C7.53137 9.2 7.8 8.93137 7.8 8.6V7.1ZM1.5 1.4C1.5 0.737259 2.03726 0.200001 2.7 0.200001H7.2C7.86274 0.200001 8.4 0.737259 8.4 1.4V8.6C8.4 9.26274 7.86274 9.8 7.2 9.8H2.7C2.03726 9.8 1.5 9.26274 1.5 8.6V1.4ZM4.65 8.15C4.65 7.98432 4.78431 7.85 4.95 7.85H4.9545C5.12019 7.85 5.2545 7.98432 5.2545 8.15C5.2545 8.31569 5.12019 8.45 4.9545 8.45H4.95C4.78431 8.45 4.65 8.31569 4.65 8.15Z" fill="black"/></svg>,
		className: 'nexter-responsive-tabs',
	} ],
}

const defaultDataBG = {
    openBg: 0,
    bgType: 'color',
    videoSource: 'local',
    bgDefaultColor: '',
    bgGradient: '',
};

class Nexter_Background extends Component {

    componentWillMount(){
        const { value } = this.props
		this.props.onChange( Object.assign( {}, defaultDataBG, ( value || {} ) ));
    }

    setSettings(val, type) {
        const { value, onChange } = this.props
        if( 'bgimgParallax' == type ){
            onChange( Object.assign( {}, value, { bgimgAttachment: ( val == 'fixed' ? val: (val=='animated') ? 'fixed' : 'scroll' ), [type]: val } ) );
        }else{
            onChange( Object.assign( {}, value, { openBg: 1 }, { [type]: val } ) );
        }
    }
	
	
    render(){
		
        const { value, label, separator, help , diff } = this.props
        const fieldLabel = label ? label : __('Background', 'nexter-extension');
       
		const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';
        return (
            <div className={`nexter-field-background nexter-field-color-advanced nexter-field ${sep}`}>
                
                <div className="nexter-mb-15 nexter-d-flex nexter-align-center">
                    <label  className={ nexterfieldChange( '' , ( value && value.openBg == 0 ) ? '' : value?.bgType ) } >{ fieldLabel }{/* <Nexter_Help>{help}</Nexter_Help> */}</label>
					{(value && (value.openBg == 1 && value.bgType != '')) &&
                        <div className="nexter-flex nexter-reset-color">
                            <Tooltip text={ __( 'Clear', 'nexter-extension' )  }>
                                <span className="nexter-border-clear" onClick={() => this.setSettings( '', 'bgType' ) } role="button">
									{Nexter_Icons.ClearIcon}
								</span>
                            </Tooltip>
                        </div>
                    }
                    <div className="nexter-field-button-list nexter-ml-auto">
                        {
							
                            this.props.sources.map((data, index) => {
                                return (
                                    <button className={((value && value.bgType == data && value.openBg) ? 'active' : '') + ' nexter-button'} key={index} onClick={() => this.setSettings(data, 'bgType')}>
                                        {data == 'color' &&
                                            <Tooltip text={ __( 'Color', 'nexter-extension' )  }>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none" viewBox="0 0 10 10"><path fill="#000" d="M8.821.007C8.318.06 7.712.395 6.97 1.032c-1.344 1.151-2.929 3.14-3.95 4.57a2.18 2.18 0 0 0-1.995.784C.17 7.453.885 8.406.08 9.254c-.14.148-.09.391.098.471 1.317.564 3.001.213 3.79-.62.484-.51.746-1.26.614-1.968C5.994 6.054 7.945 4.384 9.05 2.998c.612-.767.922-1.384.95-1.886.035-.677-.49-1.177-1.178-1.105ZM3.544 8.702c-.535.563-1.717.891-2.77.61.59-.938.083-1.78.708-2.56.513-.64 1.544-.82 2.143-.221.7.7.374 1.69-.081 2.17Zm.06-2.908c.143-.198.369-.505.65-.872l.961.962c-.354.29-.65.524-.841.673a1.931 1.931 0 0 0-.77-.763Zm5.81-4.714c-.067 1.231-2.81 3.634-3.747 4.427l-1.05-1.05C5.387 3.48 7.649.718 8.883.59c.329-.035.547.173.53.49Z"/></svg>
                                            </Tooltip>
                                        }
                                        {data == 'image' &&
                                            <Tooltip text={ __( 'Image', 'nexter-extension' )  }>
                                               <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12"><g clipPath="url(#a)"><path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".5" d="M2.111 11H9.89C10.503 11 11 10.502 11 9.889V2.11C11 1.497 10.502 1 9.889 1H2.11C1.497 1 1 1.497 1 2.111V9.89C1 10.503 1.497 11 2.111 11Zm0 0 6.111-6.111L11 7.667M4.889 4.056a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
                                            </Tooltip>
                                        }
                                        {data == 'gradient' &&
                                            <Tooltip text={ __( 'Gradient', 'nexter-extension' )  }>
                                               	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12"><path fill="#000" fillRule="evenodd" d="M.75 2C.75 1.31 1.31.75 2 .75h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V2Zm9.347-.744-8.84 8.841A.75.75 0 0 0 2 10.75h8a.75.75 0 0 0 .75-.75V2a.75.75 0 0 0-.653-.744Z" clipRule="evenodd"/></svg>
                                            </Tooltip>
                                        }
                                        {data == 'video' &&
                                            <Tooltip text={ __( 'Video', 'nexter-extension' )  }>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 14"><path d="M18 1.679v10.929a.602.602 0 0 1-.392.593.71.71 0 0 1-.251.05.598.598 0 0 1-.452-.191l-4.048-4.048v1.667c0 .797-.283 1.478-.849 2.044a2.786 2.786 0 0 1-2.044.849H2.893a2.786 2.786 0 0 1-2.044-.849A2.786 2.786 0 0 1 0 10.679V3.608c0-.797.283-1.478.849-2.044A2.786 2.786 0 0 1 2.893.715h7.071c.797 0 1.478.283 2.044.849.566.566.849 1.247.849 2.044v1.657l4.048-4.038a.598.598 0 0 1 .452-.191.71.71 0 0 1 .251.05c.261.114.392.311.392.593z"/></svg>
                                            </Tooltip>
                                        }
                                    </button>
                                )
                            })
                        }
                    </div>
                    
                </div>
                {(value && value.bgType === "color") &&
                    <div className="nexter-background-inner">
                       	<Nexter_Color 
					   		label={ fieldLabel + ' ' + __('Color', 'nexter-extension') } 
							value={ value.bgDefaultColor } 
							onChange={ (val)=>this.setSettings( val, 'bgDefaultColor' ) } 
							diff={ (diff && diff.bgDefaultColor) ? diff.bgDefaultColor : '' }
						/>
                    </div>
                }
                { (value && value.openBg == 1) && (value.bgType === 'image') &&
                    <div className="nexter-background-inner">
                        <Nexter_Media label={__('Background Image', 'nexter-extension')} multiple={false} type={['image']} panel={true} value={ value.bgImage } onChange={ (val) => this.setSettings(val, 'bgImage' ) } />
                        
                        {(value.bgImage && value.bgImage.url) &&
                            <Fragment>
                                { this.props.parallax &&
                                    <div className="nexter-field nexter-d-flex nexter-align-center">
                                        <div>
                                            {__('Parallax', 'nexter-extension')}
                                        </div>
                                        <div className="nexter-field-button-list nexter-ml-auto">
                                            {
                                                control.parallax.map((data, index) => {
                                                    return (
                                                        <Tooltip text={data[1]}>
                                                            <button className={(value.bgimgParallax == data[0] ? 'active' : '') + ' nexter-button'} key={index} onClick={() => this.setSettings(  data[0], 'bgimgParallax' )}>
                                                                {data[0] == 'none' ?
                                                                    <i className="fas fa-ban" />
                                                                    :
                                                                    data[1]
                                                                }
                                                            </button>
                                                        </Tooltip>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                }
                                <div className="nexter-bg-image-opt">
									<Fragment>
										{ !this.props.position &&
											<TabPanel  className="nexter-bg-tabs"
												activeClass="active-tab"
												tabs={ control.devices }>
												{
												  ( tab ) => {
													let tabout;
													if ( tab.name ) {
													  if ( 'mobile' === tab.name ) {
														tabout = (
														  <Nexter_Select label={ __('Position', 'nexter-extension') } value={ value.bgimgPositionMobile } options={ control.position } onChange={ (val)=>this.setSettings( val, 'bgimgPositionMobile' ) } inlineblock={true} />
														
														);
													  } else if ( 'tablet' === tab.name ) {
														tabout = (
														  <Nexter_Select label={ __('Position', 'nexter-extension') } value={ value.bgimgPositionTablet } options={ control.position } onChange={ (val)=>this.setSettings( val, 'bgimgPositionTablet' ) } inlineblock={true} />
														 
														);
													  } else {
														tabout = (
														  <Nexter_Select label={ __('Position', 'nexter-extension') } value={ value.bgimgPosition } options={ control.position } onChange={ (val)=>this.setSettings( val, 'bgimgPosition' ) } inlineblock={true} />
														);
													  }
													}
													return <div>{ tabout }</div>;
												  }
												}
											  </TabPanel>
										}
										{ !this.props.parallax &&
											<Nexter_Select label={ __('Attachment', 'nexter-extension') } value={ value.bgimgAttachment } options={ control.attachment } onChange={ (val)=>this.setSettings( val, 'bgimgAttachment' ) } inlineblock={true} />
										}
									</Fragment>
									{ ( !this.props.size || !this.props.repeat ) &&
									<Fragment>
										{ !this.props.repeat &&
											<TabPanel  className="nexter-bg-tabs"
											activeClass="active-tab"
											tabs={ control.devices }>
											{
											  ( tab ) => {
												let tabout;
												if ( tab.name ) {
												  if ( 'mobile' === tab.name ) {
													tabout = (
													  <Nexter_Select label={ __('Repeat', 'nexter-extension') } value={ value.bgimgRepeatMobile } options={ control.repeat } onChange={ (val)=>this.setSettings( val, 'bgimgRepeatMobile' ) } inlineblock={true} />
													
													);
												  } else if ( 'tablet' === tab.name ) {
													tabout = (
													  <Nexter_Select label={ __('Repeat', 'nexter-extension') } value={ value.bgimgRepeatTablet} options={ control.repeat } onChange={ (val)=>this.setSettings( val, 'bgimgRepeatTablet' ) } inlineblock={true}/>
													 
													);
												  } else {
													tabout = (
													  <div>
													  <Nexter_Select label={ __('Repeat', 'nexter-extension') } value={ value.bgimgRepeat } options={ control.repeat } onChange={ (val)=>this.setSettings( val, 'bgimgRepeat' ) } inlineblock={true} />
													  </div>
													);
												  }
												}
												return <div>{ tabout }</div>;
											  }
											}
										  </TabPanel>
			
										}
										{ !this.props.size && 
											<TabPanel  className="nexter-bg-tabs"
											activeClass="active-tab"
											tabs={ control.devices }>
											{
											  ( tab ) => {
												let tabout;
												if ( tab.name ) {
												  if ( 'mobile' === tab.name ) {
													tabout = (
													  <Nexter_Select label={ __('Size', 'nexter-extension') } value={ value.bgimgSizeMobile } options={ control.size } onChange={ (val)=>this.setSettings( val, 'bgimgSizeMobile' ) } inlineblock={true} />
													
													);
												  } else if ( 'tablet' === tab.name ) {
													tabout = (
													  <Nexter_Select label={ __('Size', 'nexter-extension') } value={ value.bgimgSizeTablet } options={ control.size } onChange={ (val)=>this.setSettings( val, 'bgimgSizeTablet' ) } inlineblock={true} />
													 
													);
												  } else {
													tabout = (
													  <Nexter_Select label={ __('Size', 'nexter-extension') } value={ value.bgimgSize } options={ control.size } onChange={ (val)=>this.setSettings( val, 'bgimgSize' ) } inlineblock={true} />
													);
												  }
												}
												return <div>{ tabout }</div>;
											  }
											}
										  </TabPanel>
											
										}
										{ !this.props.attachment && value.bgimgParallax == 'none' &&
											<Nexter_Select label={ __('Attachment', 'nexter-extension') } value={ value.bgimgAttachment } options={ control.attachment } onChange={ (val)=>this.setSettings( val, 'bgimgAttachment' ) } inlineblock={true} />
										}
									</Fragment>
									}
								</div>
                            </Fragment>
                        }
                    </div>
                }

                {(value && value.openBg == 1) && (value.bgType === "gradient") &&
                    <div className="nexter-background-inner">
                        <Nexter_Gradient inline={true} label={__('Gradient', 'nexter-extension')} 
                            value={ value.bgGradient } 
                            onChange={ val => this.setSettings(val, 'bgGradient' )}
                            opacityValue = { value.bgGradient }
                            onOpacityChange = { val => this.setSettings(val, 'bgGradient' )}
                         />
                    </div>
                }

                {(value && value.openBg == 1) && ( value.bgType == 'video' ) &&
                    <div className="nexter-background-inner">
                        <Nexter_Select label={ __('Video Source', 'nexter-extension') } value={value.videoSource} options={ [ ['local', __('Local', 'nexter-extension')], ['external', __('External', 'nexter-extension')]] } onChange={ (val)=>this.setSettings( val, 'videoSource' ) } />
                        { value.videoSource === 'external' ?
                            <TextControl
                                label={__('Video URL', 'nexter-extension')}
                                value={value.bgExternalVideo || ""  }
                                onChange={ val => this.setSettings( val, 'bgExternalVideo' )}
                            />
                            :
                            <Nexter_Media label={__('Video', 'nexter-extension')} multiple={false} type={['video']} panel={true} value={value.bgVideo} onChange={ (val) => this.setSettings( val, 'bgVideo' ) } />
                        }
                        <Nexter_Media label={__('Fallback Image (Poster)', 'nexter-extension')} multiple={false} type={['image']} panel={true} value={value.bgVideoFallback} onChange={ (val) => this.setSettings( val, 'bgVideoFallback' ) } />
                    </div>
                }
            </div>
        )
    }
}

class Nexter_Dimension extends Component {

    constructor(props) {
        super(props);
        this.state = { lock: true, current: this._filterValue(), deviceType: 'md' }
    }

    componentDidMount() {
		if(this.props.responsive && this.props.value===undefined){
			this.props.onChange( Object.assign( {}, this.props.responsive ? {'md' : {'top' : ''}} || {} : '', ( this.props.value || {} ) ));
		}
		this.checkLockValue()
    }

    handleSetDeviceType = (deviceType) => {
        this.setState({ deviceType });
    };

	
	checkLockValue(){
		const {value, responsive, device} = this.props
		if(responsive && value && value[device]!=undefined && value[device]['top']!=undefined && value[device]['right']!=undefined && value[device]['top'] === value[device]['right'] && value[device]['top'] === value[device]['bottom'] && value[device]['top'] === value[device]['left']){
			this.setState( { lock: true } )
		}else if(responsive && (value==undefined || value[device]==undefined)){
			this.setState( { lock: true } )
		}else if (!responsive && value && value.top === value.right && value.top === value.bottom && value.top === value.left) {
            this.setState( { lock: true } )
        }else{
            this.setState( { lock: false } )
        }
	}
	
    _filterValue(val) {

        const { value,responsive, device } = this.props
        if (typeof value == 'object' && typeof value !== 'undefined' && Object.keys(value).length > 0) {
            
            if (val) {
                return responsive ? value[device] ? value[device][val] || '' : '' : value[val];
            } else {
                return responsive ? value[device] || '' : value;
            }
        } else {
            return value ? responsive ? value[device] || '' : value : '';
        }
    }

    setSettings(action, position) {

        const { value,responsive, onChange, max, min,noLock, device } = this.props
        let newVal = action;
        if (typeof min != undefined) { newVal = action < min ? min : newVal }
        if (max) { newVal = action > max ? max : newVal }
       
		let data = (this.state.lock && position != 'unit') ? { 'top': newVal, 'right': newVal, 'bottom': newVal, 'left': newVal } :  nexter_defineProperty({}, position, newVal);
		
		//const final = responsive ? Object.assign({}, value, nexter_defineProperty({}, device, data)) : data;
		
		data = Object.assign({}, responsive ? value[device] || {} : value, data)
		
        const final = Object.assign({}, value, responsive ? nexter_defineProperty({}, device, data) : data)
        
		final.unit = data.unit || 'px'
        onChange(final)
        this.setState({ current: final })
    }

    render() {
        const { unit, label, responsive, noLock, device, onDeviceChange, clientId, min, max, separator, deviceAlign, help ,value , diff  } = this.props;
		
        let responsiveDevice = responsive ? device ? device : this.state.device : window.nexterDevice;
		const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';
        
        let deviceUnit = this._filterValue('unit');
        if(deviceUnit=='' || deviceUnit==undefined){
            deviceUnit = (this.props.value && this.props.value.unit) ? this.props.value.unit : ''
        }
        
        return (
            <div className={'nexter-field-dimension nexter-field nexter-d-flex ' + (responsive ? 'nexter-responsive' : '') +' '+ (sep ? sep : '')}>
                <div className="nexter-d-flex nexter-mb-10">
                    {label &&
                        <label className={ nexterfieldChange( diff , value , responsive , device , true ) } htmlFor={'input'}>
                            {label}
                        </label>
                    }
					
					{ responsive && <Nexter_Device align={deviceAlign || ''} device={responsiveDevice} setDeviceType={this.handleSetDeviceType} commonResponsiveDevice={device} className="nexter-ml-10" onChange={(val) => { device && onDeviceChange ? onDeviceChange(val) : this.updateDevice(val) }} /> }
                    {/* <Nexter_Help>{help}</Nexter_Help> */}
                    {unit &&
                        <div className="nexter-unit-btn-group nexter-ml-auto">
                            {/* {(typeof unit == 'object' ? unit : ['px', 'em', '%']).map((value, index) => (
                                <button className={(this.props.value && value == deviceUnit) ? 'active' : ''} key={index} onClick={() => {
                                    this.setSettings(value, 'unit');
                                }}>{value}</button>
                            ))} */}
                            <Nexter_Select value={ deviceUnit } options={ unit } onChange={ (val)=> this.setSettings(val, 'unit') } inlineblock={ false } />
                        </div>
                    }
                </div>
                <div className="nxp-field-child">
                    <div className={"nexter-dimension-input-group" + (!this.props.noLock ? ' hasLock' : '')}>
                        {['top', 'right', 'bottom', 'left'].map((val, index) => (
                        <Tooltip text={ label && label.includes("Radius") ?  (( index == 0 ) ? __('Top-left', 'nexter-extension')  : ( index == 1 ) ? __('Top-right', 'nexter-extension') : ( index == 2 ) ? __('Bottom-right', 'nexter-extension')  : ( index == 3 ) ? __('Bottom-left', 'nexter-extension') :  '' )  :  __( val.charAt(0).toUpperCase() + val.slice(1) , 'nexter-extension') } delay={0} placement={'top-end'}>
                            <span>
                                <input type='number' {...typeof min != undefined ? { min } : ''} {...max ? { max } : ''} key={index} value={Number(this._filterValue(val))}
                                onChange={
                                    (v) => {
                                        this.setSettings(v.target.value, val)
                                        if (clientId) {
                                        
                                        }
                                    }}
                                onBlur={
                                    (v) => {
                                        if (clientId) {
                                        
                                        }
                                    }
                                } />
                                <div className="previewIcon"> { label && label.includes("Radius") ? Nexter_Icons['radim'+val] : Nexter_Icons['dim'+val] }</div>
                            </span>
                        </Tooltip>
                        ))}
                        {!this.props.noLock &&
                            <button className={(this.state.lock ? 'active ' : '') + 'nexter-button'} onClick={() => this.setState({ lock: !this.state.lock })}>
                               <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"><path fill="#010101" fillRule="evenodd" d="M8.12155 1.87842c-.26265 0-.52272.05173-.76537.15224-.24265.10051-.46313.24783-.64885.43354L5.64667 3.52486c-.19526.19527-.51184.19527-.7071 0-.19527-.19526-.19527-.51184 0-.7071L6.00023 1.7571c.27857-.27858.60929-.49956.97327-.65032.36397-.150765.75408-.228362 1.14805-.228362.39396 0 .78407.077597 1.14805.228362.36397.15076.69469.37174.9733.65032.2785.27857.4995.60929.6503.97327.1508.36397.2283.75408.2283 1.14805 0 .39396-.0775.78407-.2283 1.14805-.1508.36397-.3718.69469-.6503.97327L9.18221 7.0604c-.19526.19526-.51185.19526-.70711 0s-.19526-.51185 0-.70711l1.06066-1.06066c.18572-.18572.33304-.40619.43355-.64885.10049-.24265.15219-.50272.15219-.76536 0-.26265-.0517-.52272-.15219-.76537-.10051-.24265-.24783-.46313-.43355-.64885-.18572-.18571-.4062-.33303-.64885-.43354-.24265-.10051-.50272-.15224-.76536-.15224Zm-.35352 2.35363c.19526.19526.19526.51184 0 .7071L4.9396 7.76758c-.19526.19526-.51184.19526-.70711 0-.19526-.19526-.19526-.51184 0-.70711l2.82843-2.82842c.19526-.19527.51185-.19527.70711 0Zm-4.24268.70703c.19526.19526.19526.51184 0 .7071L2.46469 6.70684c-.37507.37508-.58578.88379-.58578 1.41422 0 .53043.21071 1.03914.58578 1.41421.37508.37508.88378.58583 1.41422.58583.26264 0 .52271-.0518.76536-.15228.24265-.10051.46313-.24783.64885-.43355l1.06066-1.06066c.19526-.19526.51184-.19526.70711 0 .19526.19526.19526.51185 0 .70711L6.00023 10.2424c-.27858.2786-.6093.4995-.97327.6503-.36398.1508-.75409.2284-1.14805.2284-.79565 0-1.55871-.3161-2.12132-.8787-.56261-.56263-.878684-1.32569-.878684-2.12134s.316074-1.55871.878684-2.12132l1.06066-1.06066c.19526-.19526.51184-.19526.7071 0Z" clipRule="evenodd"/></svg>
                            </button>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

class Nexter_Range extends Component {
    constructor(props) {
        super(props)
        this.state = { current: '', device: 'md' }
    }
    handleSetDeviceType = (deviceType) => {
        this.setState({ deviceType });
    };

    _filterValue(type) {
        const { value, responsive, device } = this.props
        if (type == 'unit') {
            return value ? (value.unit || 'px') : 'px'
			} else {
            return value ? (responsive ? (value[device] || '') : value) : ''
        }
    }

    setSettings(val, type) {
        const { value, onChange, responsive, min, max, unit, device } = this.props
        
        let final = {}
        if (unit && (value && !value.hasOwnProperty('unit'))) { final = Object.assign({}, value, nexter_defineProperty({}, 'unit', 'px')) }
        if ((type === 'unit' || type === 'unitsm' || type === 'unitxs') && responsive) {
            final = Object.assign({}, value, nexter_defineProperty({}, type, val))
        }else {
            final = (responsive) ? Object.assign({}, value, final, nexter_defineProperty({}, device, val)) : val
            final = (final!="" && min) ? (final < min ? min : final) : (final < 0 ? 0 : final)
            final = max ? (final > max ? max : final) : (final > 1000 ? 1000 : final)
        }

        onChange(final)
        this.setState({ current: final })
    }

    _minMax(type) {
        let unit = this._filterValue('unit')
        if(type=='max' && unit=='%' ){
            return 100;
        }
        return (this.props[type] && this.props[type] != 0) ? ((unit == 'rem' || unit == 'em') ? Math.round(this.props[type] / 16) : this.props[type]) : 0
    }

    _steps() {
        let unit = this._filterValue('unit')
        if(unit == '%' ){
            return 0.5;
        }
        return (unit == 'rem' || unit == 'em') ? .1 : (this.props.step || 1)
    }

    updateDevice(updatedDevice) {
        let { value, onChange, device } = this.props
        if (typeof device !== 'undefined') {
            onChange({ ...value, device: updatedDevice })
        }
        this.setState({ device: updatedDevice })
    }

    render() {
        const { unit, label, responsive, device, onDeviceChange, separator, help , deviceAlign , cssFilter , value , diff} = this.props
        let responsiveDevice = responsive ? device ? device : this.state.device : window.nexterDevice
		const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';

        let UnitResponsive = 'unit';
        let UnitValue = ( this.props.value && this.props.value.unit) ? this.props.value.unit : '';
        if(responsive && device){
            if(device != 'md'){
                UnitResponsive = 'unit'+device;
                UnitValue = (this.props.value) ? (this.props.value[UnitResponsive] || UnitValue) : UnitValue
            }
        }
        let updatedUnit;
        if(unit){
            if ( typeof unit === 'object') {
                updatedUnit = unit;
            } else {
                updatedUnit = ['px', 'em', '%'];
            }    
        }
       
        let uid = 'id-' + Date.now() + '-' + Math.floor(Math.random() * 10000);
       
        if( !cssFilter ){
            var percentage = (this._filterValue() - this._minMax('min')) / (this._minMax('max') - this._minMax('min')) * 100,
            trackColor = '.nexter-input-range.'+uid+' input[type=range]::-webkit-slider-runnable-track{ background: linear-gradient( to right, #162D9E '+percentage+'%, #E7E7F6 '+(percentage)+'% ) !important;} .nexter-input-range.'+uid+' input[type=range]::-moz-range-track{ background: linear-gradient( to right, #162D9E '+percentage+'%, #E7E7F6 '+(percentage)+'% ) !important;} ';
        }

        return (
		<div className={'nexter-field-range nexter-field ' + (responsive ? 'nexter-responsive' : '') +' '+ (sep ? sep : '')}>
                {(label || unit || responsive) &&
                    <div className="nexter-d-flex nexter-align-center">
                        {label &&
                            <label className={ nexterfieldChange( diff , value , responsive , device , false , true  ) } htmlFor={'input'}>
                                {label}
                            </label>
                        }

                        {responsive && <Nexter_Device align={deviceAlign || ''} device={responsiveDevice} commonResponsiveDevice={device} setDeviceType={this.handleSetDeviceType} className="nexter-ml-10" onChange={(val) => { device && onDeviceChange ? onDeviceChange(val) : this.updateDevice(val) }} />}

                        {/* <Nexter_Help>{help}</Nexter_Help> */}
                        { ( updatedUnit && updatedUnit != undefined ) &&
                            
                            <div className="nexter-unit-btn-group nexter-ml-auto">
                                {/* {(typeof unit == 'object' ? unit : ['px', 'em', '%']).map((value,index) => (
                                    <button className={(this.props.value && value == UnitValue) ? 'active' : ''}
										key={index.toString()} 
                                        onClick={() => {
                                            this.setSettings(value, UnitResponsive)
                                        }}
                                    >{value}</button>
                                ))} */}
                                <Nexter_Select value={ (this.props.value) ? UnitValue : '' } options={ updatedUnit } onChange={ (val)=>  this.setSettings(val, UnitResponsive) } inlineblock={ false } />
                            </div>
                        }
                    </div>
                }

                <div className="nxp-field-child">
                    <div className={"nexter-input-range "+((this.props.value && this.props.value.unit=='c') ? 'text-d-block ' : '')+ uid}>
                        {(this.props.value && this.props.value.unit=='c') ?
                            <Fragment><Nexter_Text
                                label={''}
                                value={ this._filterValue() }
                                placeholder={'clamp(1.8rem, 1.5rem + 0.8vw, 2rem)'}
                                onChange={ val => this.setSettings(val, 'range') }
                                inlineblock={false}
                            />
                            <Nexter_Note label={__('Tip : ', 'nexter-extension')} description={'<a href="https://clamp.font-size.app/" target="_blank" rel="noopener noreferrer">Generate Clamp Code</a>'} />
                            </Fragment>  
                        :
                        <Fragment>
                            <input
                                type="range"
                                min={this._minMax('min')}
                                max={this._minMax('max')}
                                value={this._filterValue()}
                                step={this._steps()}
                                onChange={e => this.setSettings(this._filterValue() == e.target.value ? '' : e.target.value, 'range')}
                            />

                            <input type="number" step={this._steps()} onChange={v => this.setSettings(v.target.value, 'range')} value={this._filterValue() + (this.props.suffix ? this.props.suffix : '')} {...(this.props.suffix && { disabled: true })} />
                        </Fragment>
                    }
                    {( this._filterValue() && trackColor )&&
                        <style>{ trackColor }</style>
                    }
                    </div>
                </div>
            </div>
        )
    }
}

class Nexter_Tabs extends Component {
    constructor(props) {
        super(props)
        this.state = { activeTab: (this.props.children[0]!=undefined ? this.props.children[0].props.tabTitle : this.props.children.props.tabTitle) }
    }
	
    render() {
		
		const { activeTab } = this.state
        const { children, separator } = this.props
		
		const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';
		
        return (
			<div className={'nexter-field nexter-inspect-tabs ' + (sep ? sep : '')}>
                <div className="components-tab-panel__tabs">
					{ children[0]!=undefined ?
						children.map((tab) => {
							return(<Fragment key={tab.props.tabTitle}>
								{tab!==false &&
									<Tooltip text={__(tab.props.tabTitle, 'nexter-extension')} delay={0}>
										<button className={(tab.props.tabTitle === activeTab ? 'active-tab' : '') + ' components-button nexter-tab-menu'} onClick={ () => this.setState({ activeTab: tab.props.tabTitle }) }>{tab.props.tabTitle}</button>
									</Tooltip>
								}
								</Fragment>
							)
						})
					:
						<Tooltip text={__(children.props.tabTitle, 'nexter-extension')} delay={0}>
							<button className={(children.props.tabTitle === activeTab ? 'active-tab' : '') + ' components-button nexter-tab-menu'} onClick={ () => this.setState({ activeTab: children.props.tabTitle }) }>{children.props.tabTitle}</button>
						</Tooltip>
					}
                </div>
				
				<div className='nexter-field-tab-items'>
					{ children[0]!=undefined ?
						children.map((tab) => {
						return(<Fragment key={tab.props.tabTitle}>
								{tab!==false &&
									tab.props.tabTitle === activeTab ? tab : ""
								}
								</Fragment>
							)
						})
					:
						children.props.tabTitle === activeTab ? children : ""
					}
				</div>
            </div>
        )
    }
}

class Nexter_Tab extends Component {
    constructor(props) {
        super(props)
    }
	
    render() {
		
        const { label, children, onTabChange } = this.props
		onTabChange && onTabChange();
        return (
			<Fragment>
			{
				Array.isArray(children) ? children.map((item) =>
                    item
                ) : children
			}
			</Fragment>
        )
    }
}


const defaultDataBdr = {
	openBorder: 0,
	type: '',
    color: '',
    width: {},
}

class Nexter_Border extends Component {
    constructor(props) {
        super(props)
    }
	
	componentWillMount(){
        const { value } = this.props
		this.props.onChange( Object.assign( {}, defaultDataBdr, ( value || {} ) ));
    }
    setSettings(type, val) {
        this.props.onChange(Object.assign({}, this.props.value,{ openBorder: type == 'type' && val == '' ? 0 : 1 }, nexter_defineProperty({}, type, val)))
    }
	
    render() {
        
        const { value, label,device,onDeviceChange, separator, disableWidthColor, help , diff } = this.props
		
        const defData = [['solid', __('Solid', 'nexter-extension')], ['dotted', __('Dotted', 'nexter-extension')], ['dashed', __('Dashed', 'nexter-extension')], ['double', __('Double', 'nexter-extension')]]
        
		const fieldlabel = label ? label : __('Border', 'nexter-extension');
		
		const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';
        return (
			<div className = {`nexter-field nexter-field-border ${sep}`} >
            <div className="nexter-field nexter-field-border nexter-d-flex nexter-align-center">
                <div className="">
                    {fieldlabel && <label className={ nexterfieldChange( '' , ( value && value.openBorder == 0 ) ? '' : value.type )}>{fieldlabel}
                        {/* <Nexter_Help>{help}</Nexter_Help> */}
                    </label>}
                </div>
				{(value && value.type) &&
					<div className="nexter-reset-color">
						<Tooltip text={__('Clear', 'nexter-extension')} delay={0}>
							<span className="nexter-border-clear" onClick={() => this.setSettings('type', '')} role="button">
								{Nexter_Icons.ClearIcon}
							</span>
						</Tooltip>
					</div>
				}
				<div className="nexter-field-button-list nexter-ml-auto">
					{
						defData.map((data, index) => {
							return (
								<Tooltip text={data[1]} key={index} delay={0} >
									<button className={((value && value.type == data[0]) ? 'active' : '') + ' nexter-button'} onClick={() => this.setSettings('type',data[0])}>
										<span className={`nexter-field-border-type nexter-d-flex nexter-align-center`} >
											{ Nexter_Icons[data[0]] }
										</span>
									</button>
								</Tooltip>
							)
						})
					}
					{/* nexter-field-border-type-${data[0]} */}
				</div>
            </div>
			{ (!disableWidthColor && value && value.type) && 
				<Fragment>
					<Nexter_Color 
						label={ __('Border Color', 'nexter-extension') }
						value={ value.color }
						onChange={ (val) => this.setSettings( 'color', val ) }
						diff={ (diff && diff.color) ? diff.color : '' }
					/>
					<Nexter_Dimension 
						label={__('Border Width', 'nexter-extension')} 
						value={value.width}
						onChange={ (val) => this.setSettings( 'width', val ) }
						min= {0}
						max={20}
						unit= {['px', 'em', '%']}
						responsive={ true }
						device= {device}
						onDeviceChange = { ( value ) => onDeviceChange( value ) }
						diff = { (diff && diff.width) ? diff.width : { md : { top: "", right:"", bottom:"", left:""} } }
					/>
				</Fragment>
			}
            </div>
        )
    }
}

// Export for ease of importing in individual blocks.
export {
	TypographyStyles,
}

const defaultDataTypo = {
	openTypography: 1,
    size: '',
    height: '',
    spacing: '',
    fontFamily: {},
}

class Nexter_Typography extends Component {

	constructor(props) {
		super(props)
		this.state = {Status : false }
	}
	
	componentDidMount() {
		const { value } = this.props
	}
	
	componentWillMount(){
        const { value } = this.props
		this.props.onChange( Object.assign( {}, defaultDataTypo, ( value || {} ) ));
    }
	
	setSettings(value, type) {
		let data={}
        this.props.onChange(Object.assign({}, this.props.value,{}, data, nexter_defineProperty({}, type, value)))
    }
	
	render() {

		let fontSize
		let lineHeight
		let fontFamily
		let letterSpacing
		let textTransforms
		let textDecorations
		let fontStyles
		let fontAdvancedControls
		let fontTypoAdvancedControls
		let showAdvancedFontControls
		let resetFontAdvancedControls
		
		const { Status } = this.state
		
		const {
			label,
			value,
			device,
			onDeviceChange,
			disableFontFamily,
			disableFontSize,
			disableLineHeight,
			disableLetterSpacing,
			disableTextTransform,
			disableTextDecoration,
			disableFontStyle,
			textTransform,
			textDecoration,
			fontStyle,
			labelDisable,
			disableAdvancedOptions = false,
			separator,
			disableGlobal,
			help,
			diff
		} = this.props
		
		const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';
		
		const textTransformOptions = [
			{ label: __('Ag'), value: 'capitalize', title: __('Capitalize', 'nexter-extension') },
			{ label: __('AG'), value: 'uppercase', title: __('Uppercase', 'nexter-extension') },
			{ label: __('ag'), value: 'lowercase', title: __('Lowercase', 'nexter-extension') },
		];

		const textDecorationOptions = [
			{ svg: Nexter_Icons.none  , value: 'default', title: __('Default', 'nexter-extension') },
			{ svg: Nexter_Icons.underLine  , value: 'underline', title: __('Underline', 'nexter-extension') },
			{ svg: Nexter_Icons.uperLine  , value: 'overline', title: __('Overline', 'nexter-extension') },
			{ svg: Nexter_Icons.lineThro   , value: 'line-through', title: __('Line Through', 'nexter-extension') },
		];

		const fontStyleOptions = [
			{ svg: Nexter_Icons.none , value: 'default', title: __('Default', 'nexter-extension') },
			{ svg: Nexter_Icons.textNormal , value: 'normal', title: __('Normal', 'nexter-extension') },
			{ svg: Nexter_Icons.textItalic, value: 'italic', title: __('Italic', 'nexter-extension') },
			{ svg: Nexter_Icons.textOblique, value: 'oblique', title: __('Oblique', 'nexter-extension') },
		];
		
		
		if( true !== disableFontFamily ) {
			fontFamily = (
			<Fragment>
				{ (value && value.fontFamily) &&
				<FontFamilyControl 
					value={ value.fontFamily } 
					onChange={ val => this.setSettings(val, 'fontFamily' )}
				 />
				}
				</Fragment>
			)
		}

		if( true !== disableLineHeight ) {
			lineHeight = (
				<Fragment>
				{ (value) &&
					<Nexter_Range
						label={__('Line Height', 'nexter-extension')}
						value={ value.height }
						onChange={height => this.setSettings( height, 'height')}
						min={1}
						max={150}
						unit={ true }
						responsive={ true }
						device={ device }
						onDeviceChange = { ( value ) => onDeviceChange( value ) }
						diff = { (diff && diff.height) ? diff.height : { md : '' , unit : '' } }
					/>
				}
				</Fragment>
			)
		}

		if( true !== disableLetterSpacing ) {
			letterSpacing = (
				<Fragment>
				{ (value) &&
					<Nexter_Range
						label={__('Letter Spacing', 'nexter-extension')}
						value={ value.spacing }
						onChange={spacing => this.setSettings( spacing, 'spacing')}
						min={-10}
						max={20}
						step={0.1}
						unit={ true }
						responsive={ true }
						device={ device }
						onDeviceChange = { ( value ) => onDeviceChange( value ) }
						diff = { (diff && diff.spacing) ? diff.spacing : { md : '' , unit : '' } }
					/>
				}
				</Fragment>
			)
		}

		if( true !== disableFontSize ) {
			fontSize = (
				<Fragment>
				{ (value) &&
					<Nexter_Range
						label={__('Font Size', 'nexter-extension')}
						value={ value.size }
						onChange={size => this.setSettings( size, 'size')}
						min={1}
						max={150}
						unit={['px', 'em', 'rem', '%', 'c']}
						responsive={ true }
						device={ device }
						onDeviceChange = { ( value ) => onDeviceChange( value ) }
						diff = { (diff && diff.size) ? diff.size : { md : '' , unit : "px" } }
					/>
				}
				</Fragment>
			)
		}

		if( true !== disableTextTransform ) {
			textTransforms = (
				<Fragment>
				{ (value) &&
					<Nexter_RadioAdvanced
						label={__('Text Transform', 'nexter-extension')}
						value={ value.textTransform }
						onChange={ textTransform => this.setSettings( textTransform, 'textTransform') }
						options={textTransformOptions}
						diff = { (diff && diff.textTransform) ? diff.textTransform : '' }
					/>
				}
				</Fragment>
			)
		}

		if( true !== disableTextDecoration ) {
			textDecorations = (
				<Fragment>
				{ (value) &&
					<Nexter_RadioAdvanced
						label={__('Text Decoration', 'nexter-extension')}
						options= { textDecorationOptions }
						value={ value.textDecoration }
						onChange={ textDecoration => this.setSettings( textDecoration, 'textDecoration') }
						diff = { (diff && diff.textDecoration) ? diff.textDecoration : '' }
						inlineblock = { true }
					/>
				}
				</Fragment>
			)
		}

		if( true !== disableFontStyle ) {
			fontStyles = (
				<Fragment>
				{ (value) &&
					<Nexter_RadioAdvanced
						label={__('Font Style', 'nexter-extension')}
						options= { fontStyleOptions }
						value={ value.fontStyle }
						onChange={ fontStyle => this.setSettings( fontStyle, 'fontStyle') }
						diff = { (diff && diff.fontStyle) ? diff.fontStyle : '' }
					/>
				}
				</Fragment>
			)
		}

		if( true !== disableFontFamily && true !== disableFontSize ) {
			
			resetFontAdvancedControls =  (
				<div className="nexter-reset-color">
					<Tooltip text={__('Clear', 'nexter-extension')}>
						<span className="nexter-border-clear nexter-flex" onClick={() => { this.setState({Status: false }); this.setSettings( 0, 'openTypography'); }} role="button">
							{Nexter_Icons.ClearIcon}
						</span>
					</Tooltip>
				</div>
			)
		} else {
			showAdvancedFontControls = (
				<Fragment>
				<Popover position={'bottom right'} >
					{ fontFamily }
					{ fontSize }
					{ lineHeight }
					{ letterSpacing }
					{ fontStyles }
					{ textTransforms }
					{ textDecorations }
				</Popover>
				</Fragment>
			)
		}

		if( true !== disableFontFamily && true !== disableFontSize ) {
			fontTypoAdvancedControls =  (
				<div className={"nexter-field nexter-flex nexter-inline-block nexter-typography-option-actions "}>
					{!labelDisable && <label className={"nexter-mb-0" + nexterfieldChange( '' , ( value.openTypography == 0 ) ? '' : value.openTypography ) }>{this.props.label ? this.props.label : __('Typography', 'nexter-extension') }
                        {/* <Nexter_Help>{help}</Nexter_Help> */}
                        </label> }
					<div className={"nexter-flex"}>
						{value.openTypography ===1 && resetFontAdvancedControls }
						<Dropdown
							popoverProps={ { placement: 'top-start' } }
							className={"nexter-ml-auto"}
							contentClassName="nexter-popover-style nexter-transform-pop"
							renderToggle={({ isOpen, onToggle }) => (
								<Fragment>
									<button className={"nexter-typo-setttings"+((value.openTypography ===1 && !Status) ? ' active' : '')} isPrimary onClick={() => { onToggle(); {!isOpen && this.setState({Status: false });  this.setSettings( 1,'openTypography');} }}  aria-expanded={isOpen}>
										{ Nexter_Icons.toolset }
									</button>
								</Fragment>
								
							)}
							renderContent={() => (
								<div className="nexter-typography-advanced">
									{ fontFamily }
									{ fontSize }
									{ textTransforms }
									{ fontStyles }
									{ textDecorations }
									{ lineHeight }
									{ letterSpacing }
								</div>
							)}
						/>
					</div>
				</div>
			)
		}

		return (
			<div className={"nexter-typography-options " + (sep ? sep : '')}>
				{ !disableAdvancedOptions &&
					<Fragment>
						{ fontTypoAdvancedControls }
					</Fragment>
				}
			</div>
		)
	}
}

const defaultDataBS = {
	openShadow: false,
    inset:'',
    horizontal: 2,
    vertical: 2,
    blur: 3,
    spread: 0,
    color:'rgba(0, 0, 0, .2)'
}

class Nexter_BoxShadow extends Component {
    
	constructor(props) {
		super(props)
		this.state = {Status : false,globalShadow : {} }
	}
	
	async getGlobalShadow() {
		let shadows ='';
		const globalData = await JSON.parse(localStorage.getItem("nexter-Global-SetSettings"));
		
		if(globalData!=undefined && (shadows = globalData.boxshadow) !=undefined){
			this.setState({globalShadow: shadows});
		}
	}
	
	componentDidMount() {
		const { value } = this.props
	}
	
	componentWillMount(){
        this.props.onChange( Object.assign( {}, defaultDataBS, ( this.props.value || {} ) ));
	}

    setSettings( type, value ){
		let data={}
        this.props.onChange( Object.assign( {}, this.props.value ,{}, data, nexter_defineProperty({}, type, value || 0) ) )
    }

    render(){
        const {label, value, istextShadow, separator, labelDisable, disableGlobal, help , diff } = this.props;
        const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';
        
		const {Status} = this.state
		
		return(
            <div className={`nexter-field nexter-flex nexter-field-boxshadow nexter-inline-block ${sep}`}>
				{!labelDisable && <label className={"nexter-mb-0" + nexterfieldChange( '' , ( value.openShadow == 0 ) ? '' : value.openShadow )}>{label ? label : __('Box Shadow', 'nexter-extension') }
					{/* <Nexter_Help>{help}</Nexter_Help> */}
					</label> }
				{(value != '' && value.openShadow!==0) &&
                    <div className="nexter-reset-color">
						<Tooltip text={__('Clear', 'nexter-extension')} delay={0}>
                            <span className="nexter-border-clear nexter-flex" onClick={() => { this.setState({Status: false }); this.setSettings( 'openShadow', false); }} role="button">
								{Nexter_Icons.ClearIcon}
							</span>
						</Tooltip>
                    </div>
                }
				<div className={"nexter-flex"}>
					<Dropdown
						popoverProps={ { placement: 'top-start' } }
						className={"nexter-ml-auto"}
						contentClassName="nexter-popover-style"
						renderToggle={({ isOpen, onToggle }) => (
							<Fragment>
								<button className={"nexter-shadow-setttings"+((value.openShadow ===true && !Status) ? ' active' : '')} isPrimary onClick={() => { onToggle(); {!isOpen && this.setState({Status: false }); this.setSettings( 'openShadow', true); } }}  aria-expanded={isOpen}>
									{Nexter_Icons.toolset}
								</button>
							</Fragment>
							
						)}
						renderContent={() => (
							<Fragment>
							<Nexter_Color
								label={__('Color', 'nexter-extension')}
								value={ value.color || '' }
								onChange={ val => this.setSettings( 'color', val ) }
								diff = { (diff && diff.color) ? diff.color : '' }
							/>
							<div className="nexter-field nexter-d-flex nexter-align-justified boxshadow-content">
								<Nexter_Range
									label={__('Horizontal (X)', 'nexter-extension')}
									value={value.horizontal || ''}
									onChange={ val => this.setSettings( 'horizontal', val ) }
									min={-100}
									max={100}
									unit = {''}
									diff = { (diff && diff.horizontal) ? diff.horizontal : '' }
								/>
								<Nexter_Range
									label={__('Vertical (Y)', 'nexter-extension')}
									value={value.vertical || ''} 
									onChange={ val => this.setSettings( 'vertical', val ) }
									min={-100}
									max={100}
									diff={( diff && diff.vertical ) ? diff.vertical : ''}
								/>
								<Nexter_Range
									label={__('Blur', 'nexter-extension')}
									value={value.blur || ''} 
									onChange={ val => this.setSettings( 'blur', val ) }
									max={100}
									diff = { ( diff && diff.blur ) ? diff.blur : '' }
								/>
								{!this.props.istextShadow &&  
									<Nexter_Range
										label={__('Spread', 'nexter-extension')}
										value={value.spread || ''} 
										onChange={ val => this.setSettings( 'spread', val ) }
										min={-100}
										max={100}
										diff = { ( diff && diff.spread ) ? diff.spread : '' }
									/>
								}
							</div>
							{ (value && value.openShadow == 1 && !this.props.istextShadow && !this.props.disableInset) && !this.props.istextShadow &&
								<Nexter_RadioAdvanced label={''} value={value.inset} onChange={ val => this.setSettings( 'inset', val ) }
									options={[
										{ label: __('Inset', 'nexter-extension'), value: 'inset', title: __('Inset', 'nexter-extension') },
										{ label: __('Outset', 'nexter-extension'), value: '', title: __('Outset', 'nexter-extension') }
									]}
									inlineblock ={true}
								/>
							}
							</Fragment>
						)}
					/>
				</div>
            </div>
        )
    }
}

class Nexter_Label_Heading extends Component {
    constructor(props) {
        super(props)
    }
	
    render() {
        const { label, separator, color } = this.props
		const sep = (separator!='' && separator=='before') ? 'nexter-separator-before' : (separator!='' && separator=='after') ? 'nexter-separator-after' : '';
		const styleColor = (color!='') ? { color: color } : '';
        return (
			<div className={'nexter-field nexter-label-headings ' + (sep ? sep : '')} style={styleColor} >{ label }</div>
        )
    }
}

export default {Nexter_Device, Nexter_RadioAdvanced, Nexter_Text, Nexter_Color, Nexter_Media, Nexter_Select, Nexter_Gradient, Nexter_Background, Nexter_Dimension, Nexter_Range, Nexter_Tabs, Nexter_Tab, Nexter_Border, Nexter_Typography, Nexter_BoxShadow, Nexter_Label_Heading}